<template>
	<ja-modal :show="show" class="sync-modal">
		<ja-close-button name="close" @click.native="closeModal"></ja-close-button>

		<div class="modal-content">
			<h3 class="title">{{ $t('syncHeading') }}</h3>
			<div>
				<div class="result-container">
					<div v-if="success" class="result-sucess">
						<svgicon name="info" class="info"></svgicon>
						{{ message }}
					</div>

					<div v-if="failure" class="result-failed">
						<svgicon name="info" class="info"></svgicon>
						{{ message }}
					</div>
				</div>
				<div class="button-wrapper">
					<ja-button
						class="small"
						name="syncButton"
						:success="success"
						:disabled="success"
						@click.native="startSync"
					>
						{{ $t('sync') }}
					</ja-button>
				</div>
			</div>
		</div>
	</ja-modal>
</template>
<script>
import Modal from '@/components/Modal/Modal';
import Button from '@/components/ui/Button';
import UserData from '@/mixins/UserData';
import DateFormat from '@/mixins/DateFormat';
import CloseButton from '@/components/ui/CloseButton';
import axios from 'axios';

export default {
	components: {
		jaButton: Button,
		jaModal: Modal,
		jaCloseButton: CloseButton
	},
	mixins: [UserData, DateFormat],

	props: {
		show: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			success: false,
			failure: false,
			message: null
		};
	},
	methods: {
		closeModal() {
			this.$emit('closeModal');

			if (this.success) {
				this.success = false;
			}
		},
		startSync() {
			this.failure = false;
			if (this.success) {
				// reload page
				this.$router.go();
				return;
			}

			this.$emit('loadingStartForAdmin');

			axios({
				url: '/api/Data/LocalSync',
				method: 'GET',
				reponseType: 'json',

				withCredentials: true
			}).then(response => {
				if (response.data && response.data.Success) {
					this.success = true;
					this.failure = false;
					this.message = this.$t('sucessfull');
				} else {
					this.failure = true;
					this.success = false;
					this.message = this.$t('errorSync');
				}
				this.$emit('loadingStopForAdmin');
			});
		}
	}
};
</script>
<style lang="scss" scoped>
.sync-modal {
	::v-deep .modal {
		margin: auto;
		min-height: 240px;
		max-height: 768px;
		top: unset;
	}

	::v-deep.modal-content {
		border-radius: 8px;
	}

	.close-button {
		background-color: $font-blue;
		position: absolute;
		height: 38px;
		width: 38px;
		right: 16px;
		top: 16px;
		outline: 0;
		border: 0;
		background-color: $container-bgcolor;

		@media (any-hover: hover) {
			&:hover {
				cursor: pointer;

				svg {
					fill: $hover-state;
				}
			}
		}

		svg {
			fill: $primary-state;
		}
	}

	.modal-content {
		.scrollbar {
			max-height: 720px;
		}

		height: 100%;
		width: 100%;
		padding-top: 24px;
		display: flex;
		flex-direction: column;
		text-align: left;
		background-color: $container-bgcolor;

		h3 {
			margin: 16px;
			text-align: center;
		}

		.grid {
			display: flex;
			flex-direction: column;
			padding: 0 32px 32px 32px;

			.grid-row-1 {
				display: flex;
				margin-bottom: 16px;

				> * {
					flex: 0 0 100%;
				}
			}

			.grid-row-2 {
				display: flex;
				align-items: flex-start;

				&:not(:last-child) {
					margin-bottom: 16px;
				}

				> * {
					flex: 0 0 calc(50% - 8px);

					&:first-child {
						margin-right: 16px;
					}
				}

				&.align-bottom {
					align-items: flex-end;
				}
			}

			.grid-col-3 {
				display: flex;
				align-items: flex-end;

				> :first-child {
					margin-right: 16px;
				}

				.grid-cell-2 {
					flex: 0 0 calc(66.66% - 8px);
				}

				.grid-cell-1 {
					flex: 0 0 calc(33.33% - 8px);
				}
			}
		}
		.result-container {
			display: flex;
			justify-content: center;
			.result-sucess,
			.result-failed {
				font-family: 'RobotoMedium';
				color: #004cd0;
				margin-bottom: 8px;
				letter-spacing: 0.5px;
				@media (min-width: $breakpoint-mid) {
					font-size: 18px;

					.svg-icon {
						width: 24px;
						height: 24px;
					}
				}
				.svg-icon {
					margin-right: 10px;
				}
			}
		}
		.warning-message {
			display: flex;
			justify-content: center;
			font-family: 'RobotoMedium';
			color: #283eff;
			margin-bottom: 38px;
			letter-spacing: 0.5px;
			padding: 50px 60px 0 60px;
			text-align: center;

			@media (min-width: $breakpoint-mid) {
				font-size: 18px;
			}
		}
		.button-wrapper {
			text-align: center;
			margin-bottom: 64px;

			.btn-right {
				margin-left: 20px;
			}
		}
	}

	.text-align--center {
		text-align: center;
	}
}
</style>
